import type { TechnologyIconSources } from './technology-icon-sources';
import type { TechnologyIconName } from './supported-icon-names';
import { technologyIconLoaders } from './generated/loaders';

const sourcesCache = new Map<TechnologyIconName, TechnologyIconSources>();
const pendingLoads = new Map<
  TechnologyIconName,
  Promise<TechnologyIconSources>
>();

export const readCachedTechnologyIcon = (
  name: TechnologyIconName,
): TechnologyIconSources | undefined => sourcesCache.get(name);

export const loadTechnologyIcon = (
  name: TechnologyIconName,
): Promise<TechnologyIconSources> => {
  const cached = sourcesCache.get(name);

  if (cached) {
    return Promise.resolve(cached);
  }

  const pending = pendingLoads.get(name);

  if (pending) {
    return pending;
  }

  const load = technologyIconLoaders[name]()
    .then((sources) => {
      sourcesCache.set(name, sources);

      return sources;
    })
    .finally(() => {
      pendingLoads.delete(name);
    });

  pendingLoads.set(name, load);

  return load;
};
